import { MoreHorizontal } from 'lucide-react';
import {
  Dropdown,
  DropdownContent,
  DropdownItem,
  DropdownSeparator,
  DropdownTrigger,
} from '@/components/atoms/dropdown';

interface WorkspaceRowMenuProps {
  workspaceName: string;
  onRename: () => void;
  onDelete: () => void;
  /** Controlled open state (lets the parent keep one row menu open at a time). */
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

/**
 * The "⋯" overflow menu on each workspace row. Holds the management actions
 * (Edit / Delete) so they don't clutter the row.
 */
export function WorkspaceRowMenu({
  workspaceName,
  onRename,
  onDelete,
  open,
  onOpenChange,
}: WorkspaceRowMenuProps) {
  return (
    <Dropdown open={open} onOpenChange={onOpenChange}>
      <DropdownTrigger
        aria-label={`Actions for ${workspaceName}`}
        className="flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-accent-foreground"
      >
        <MoreHorizontal className="h-4 w-4" aria-hidden="true" />
      </DropdownTrigger>
      <DropdownContent align="end" className="pointer-events-auto z-[60] min-w-40">
        <DropdownItem onSelect={onRename}>Edit</DropdownItem>
        <DropdownSeparator />
        <DropdownItem onSelect={onDelete} className="text-destructive hover:text-destructive">
          Delete
        </DropdownItem>
      </DropdownContent>
    </Dropdown>
  );
}
